import * as React from "react";
import { JSX } from "react/jsx-runtime";

const ChatbotSettingsIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Clara Logo */}
    <g transform="scale(0.24)">
        <circle cx="50" cy="50" r="8" fill="#4682B4"/>
        <rect x="48" y="10" width="4" height="25" fill="#4682B4"/>
        <rect x="48" y="65" width="4" height="25" fill="#4682B4"/>
        <rect x="10" y="48" width="25" height="4" fill="#4682B4"/>
        <rect x="65" y="48" width="25" height="4" fill="#4682B4"/>
        <rect x="22" y="22" width="4" height="25" transform="rotate(-45 24 24)" fill="#4682B4"/>
        <rect x="74" y="22" width="4" height="25" transform="rotate(45 76 24)" fill="#4682B4"/>
        <rect x="22" y="74" width="4" height="25" transform="rotate(45 24 76)" fill="#4682B4"/>
        <rect x="74" y="74" width="4" height="25" transform="rotate(-45 76 76)" fill="#4682B4"/>
    </g>
    
    {/* Settings Cog small in bottom right */}
    {/* <g transform="translate(11, 11) scale(0.55)">
        <circle cx="12" cy="12" r="9" fill="white" />
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.5a2 2 0 0 1-1 1.72l-.15.1a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" stroke="#4682B4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="white" />
        <circle cx="12" cy="12" r="3" stroke="#4682B4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </g> */}
  </svg>
);

export default ChatbotSettingsIcon;
